import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'

import MuseUI from 'muse-ui'
import 'muse-ui/dist/muse-ui.css'

import '../rem.js'
import './utils/derective.js'
import './assets/stylus/index.styl'
import './assets/stylus/tooltip.styl'
import VueTouch from 'vue-touch'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import Vant from 'vant'
import 'vant/lib/index.css'

import VTooltip from 'v-tooltip'

import moment from 'moment'
import 'moment/locale/zh-cn'

import filePrefix from './utils/setFilePrefix'

import { mapKey } from './utils/mapKey'
import VueAMap from 'vue-amap'
Vue.use(VTooltip)
// 解决v.w.uh is not a constructor
setTimeout(() => {
  const amapKeys = Object.keys(localStorage).filter(key => key.match(/^_AMap_/))

  amapKeys.forEach(key => {
    localStorage.removeItem(key)
  })
  Vue.use(VueAMap)
})

VueAMap.initAMapApiLoader({
  key: mapKey,
  plugin: ['AMap.PlaceSearch', 'AMap.Geolocation'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
})

Vue.prototype.filePrefix = filePrefix

Vue.use(MuseUI)

moment.locale('zh-cn')

Vue.use(Vant)
Vue.use(MintUI)
// 引入 ECharts 主模块
const echarts = require('echarts/lib/echarts')
// 引入柱状图
require('echarts/lib/chart/bar')
require('echarts/lib/chart/pie')
require('echarts/lib/chart/line')
// 引入提示框和标题组件
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/markLine')
require('echarts/lib/component/legendScroll')
Vue.prototype.$echarts = echarts
Vue.use(VueTouch, {name: 'v-touch'})
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js